export interface DocksData {
    id: number
    dockCode: string
    status: DockStatus
    freshLocation: string
    groceryLocation: string
    devolLocation: string
    fulfillmentCenterId: number
    fulfillmentCenterName: string
    currentReceivementId: number
    isFresh: boolean
    isExpress: boolean
}

export enum GenericApiErrors {
    Failed,
}

export enum DockStatus {
    FREE = 'LIVRE',
    OCCUPIED = 'OCUPADA'
}

export interface DockManagementState {
    docks: DocksData[]
}

export interface GetDocksPayload {
    fc_id?: number
}

export interface SetDockFreeParams {
    id_dock: number
}

export interface CreateNewDockParams {
    dockCode: string,
    freshLocation: string,
    groceryLocation: string,
    fresh: boolean,
    fulfillmentCenterId: number
    express: boolean
    onSuccess?: () => void
}

export interface UpdateDockManagementField {
    key: keyof DockManagementState;
    value: DockManagementState[keyof DockManagementState];
}

export interface SetDockIsFreshPayload {
    id: number
    isFresh: boolean
    onSuccess: () => void
    onError: () => void
    badge?: string
}

export interface SetDockIsFreshData {
    id: number
    isFresh: boolean
}

export interface SetDockIsExpressPayload {
    id: number
    isExpress: boolean
    onSuccess: () => void
    onError: () => void
}

export interface SetDockIsExpressData {
    id: number
    isExpress: boolean
}

export interface DockData {
    id: number
    code: string
    defaultLocationId: number
    isFresh: boolean
    fulfillmentCenterId: number
    fulfillmentCenterName: string
    currentReceivementId: number
    isExpress: boolean
}

export interface GetDockPayload {
    id: number
    onSuccess: (dock: DockData) => void
    onError?: () => void
}
